import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { TableSearchInput } from "components/common/input";
import { MemberListTable } from "components/member";
import { PrimayPagination } from "components/common/pagination";
import type { IMemberList } from "service/interface/member";

export function MemberListPage() {
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectPage, setSelectPage] = useState<number>(1);
  const [listData, setListData] = useState<{
    count: number;
    data: IMemberList[];
  }>({ count: 0, data: [] });

  const { data } = useSWR(
    `/admin/manage/user?limit=12&offset=${
      selectPage * 12 - 12
    }&search=${searchValue}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  return (
    <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
      <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
        <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
          메모리올 관리자 화면
        </p>
        <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
          회원 관리
        </p>
        <div className="mb-[24px] mt-[16px]">
          <TableSearchInput
            value={searchValue}
            setValue={setSearchValue}
            placeholder="이름, 휴대폰 번호를 검색해보세요"
          />
        </div>
        <MemberListTable data={listData.data} />
        <div className="mt-[32px] flex items-center justify-end">
          <PrimayPagination
            listLength={Math.ceil(listData.count / 12)}
            pageNumber={selectPage}
            setPageNumber={setSelectPage}
          />
        </div>
      </div>
    </div>
  );
}
